export default {
  JS_URL: '/sdk/js/pgw-sdk-4.2.0.js',
  CSS_URL: '/sdk/css/amway/pgw-sdk-style-4.2.0.css',
  FONT_URL: '/sdk/amway/css/pgw-sdk-font-4.2.0.css',
};
